import { IHttpClient } from "../../lib/http";
import { AxiosRequestConfig } from "axios";

export interface MigrateReservationParams {
  httpClient: IHttpClient;
  propertyTicker: string;
  reservationId: string;
  isExistingReservation: boolean;
  config?: AxiosRequestConfig;
}
export async function migrateReservation({
  httpClient,
  propertyTicker,
  reservationId,
  isExistingReservation,
  config
}: MigrateReservationParams): Promise<void> {
  return httpClient.patch(
    `/api/properties/${propertyTicker}/reservations/${reservationId}/reports?isNewReservation=${
      isExistingReservation ? "false" : "true"
    }`,
    undefined,
    config
  );
}
